<template>
  <form class="institution-form form-horizontal" @submit.prevent="submit()">
    <div class="form-group" :class="{ 'has-error': errors['name'] }">
      <label for="name" class="col-sm-2 control-label">Nombre</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="name" v-model="data.name" />
        <div class="help-block" v-for="(e, i) in errors['name']" :key="i">
          {{ e }}
        </div>
      </div>
    </div>
    <div class="form-group" :class="{ 'has-error': errors['url'] }">
      <label for="url" class="col-sm-2 control-label">URL</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="url" v-model="data.url" />
        <div class="help-block" v-for="(e, i) in errors['url']" :key="i">
          {{ e }}
        </div>
      </div>
    </div>
    <div class="form-group" :class="{ 'has-error': errors['ministry_id'] }">
      <label for="ministry_id" class="col-sm-2 control-label"
        >Institución</label
      >
      <div class="col-sm-10">
        <institution-select
          id="institution_id"
          v-model="data.institution_id"
          :institutions="this.institutions"
        ></institution-select>
        <div
          class="help-block"
          v-for="(e, i) in errors['institution_id']"
          :key="i"
        >
          {{ e }}
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <a class="btn btn-default" href="backend/servicios-externos"
          >Cancelar</a
        >
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </div>
  </form>
</template>
<style lang="scss" scoped>
.el-select {
  display: block;
}
</style>
<script>
import InstitutionSelect from "./InstitutionSelect.vue";

export default {
  data: function() {
    return {
      data: _.cloneDeep(this.externalService),
      errors: {}
    };
  },
  props: ["externalService", "edit", "institutions"],
  components: {
    InstitutionSelect
  },
  methods: {
    submit: function() {
      var self = this;

      axios({
        url: self.edit
          ? "backend/servicios-externos/" + self.data.id
          : "backend/servicios-externos",
        method: self.edit ? "PUT" : "POST",
        data: self.data
      })
        .then(function(response) {
          window.location.replace(response.data.redirect);
        })
        .catch(function(error) {
          self.errors = error.response.data.errors;
        });
    }
  }
};
</script>